import { render, staticRenderFns } from "./basic-detail.vue?vue&type=template&id=58050c0b&scoped=true"
import script from "./basic-detail.vue?vue&type=script&lang=js"
export * from "./basic-detail.vue?vue&type=script&lang=js"
import style0 from "./basic-detail.vue?vue&type=style&index=0&id=58050c0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58050c0b",
  null
  
)

export default component.exports